import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { Link } from "react-router-dom";
import { LANDING_ROUTES } from "./registry";
/**
 * Перелинковка на SEO-лендинги для страниц приложения (футер сайта на "/",
 * "/faq" и т.д., футер WelcomePage). Без неё лендинги — «сироты»: на них нет
 * внутренних ссылок, и робот находит их только через sitemap.
 *
 * Лёгкий модуль: тянет только реестр путей, не кит лендингов. Стили — у
 * вызывающей стороны (className на <nav>, ссылки — обычные <a>).
 */
export const LandingLinks = ({ className, title = "Создать песню", }) => (_jsx("nav", { className: className, "aria-label": title, children: LANDING_ROUTES.map((r) => (_jsx(Link, { to: r.path, children: r.label }, r.path))) }));
